import { useState, useEffect } from 'react';

const navItems = [
  { name: '首页', href: '#hero' },
  { name: '实时快讯', href: '#updates' },
  { name: '专题合集', href: '#index' },
  { name: '平台特色', href: '#features' },
  { name: '热门话题', href: '#topics' },
  { name: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1280px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 shrink-0"
          >
            <span className="text-xl md:text-2xl font-heading text-primary-500 font-bold whitespace-nowrap">
              51吃瓜网
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  item.name === '首页'
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {item.name}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line mr-1.5"></i>
              我要爆料
            </a>
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-[fadeIn_0.2s_ease]">
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`block px-3 py-2.5 rounded-lg text-sm transition-colors cursor-pointer ${
                  item.name === '首页'
                    ? 'text-primary-500 font-medium bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="block px-3 py-2.5 mt-2 text-sm font-medium text-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-line mr-1.5"></i>
              我要爆料
            </a>
          </div>
        </div>
      )}
    </header>
  );
}